import { render, staticRenderFns } from "./coupletsControl.vue?vue&type=template&id=318870f9&scoped=true"
import script from "./coupletsControl.vue?vue&type=script&lang=js"
export * from "./coupletsControl.vue?vue&type=script&lang=js"
import style0 from "./coupletsControl.vue?vue&type=style&index=0&id=318870f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318870f9",
  null
  
)

export default component.exports